// extracted by mini-css-extract-plugin
export default {"weixin":"index_weixin_6dl-R","list":"index_list_iCyY6","img":"index_img_vrPE5","txt":"index_txt_6s9Mv","tit":"index_tit_ZUvK3","description":"index_description_T2k0z"};